import autoaUserProfile from "./userProfile"
import {USER_PROFILE_VUEX_NAMESPACE} from "./userProfile/config";

export default {
  [USER_PROFILE_VUEX_NAMESPACE]: autoaUserProfile
};
